export const APP_PATH = "/d2c";
export const BRAND_NAME = "ONWARD INSURANCE SERVICES";
export const NO_QUOTE_LABEL = "NO_QUOTE";
export const ONWARD_PROGRAM = "";
export const INIT_STATE = "CA";

export const APP_CONFIG = {
    MAKE_ICONS_PATH: APP_PATH + "/assets/images/makes",
    AUTHORIZE_ICONS_PATH: APP_PATH + "/assets/images/authorize"
}

export const EXT_API = {
    USPS: ""
}

export const COMPONENTS = {
    PROPS_SOURCES: {
        APP_STORE: "APP_STORE",
        UNKNOWN: "UNKNOWN"
    }
}

export const RELOAD_PATH = "/reload";

export const PATHS = {
    START: APP_PATH + "/quote",
    CHANGE_ZIP: APP_PATH + "/changeZip",
    VEHICLE_YMM: APP_PATH + "/quote/vehicle/{0}",
    VEHICLE_DETAILS: APP_PATH + "/quote/vehicleDetails/{0}",
    HOW_YOU_DRIVE: APP_PATH + "/quote/howYouDrive/{0}",
    ABOUT_YOU: APP_PATH + "/quote/aboutYou/{0}",
    EDUCATION_EMPLOYMENT: APP_PATH + "/quote/educationEmployment/{0}",
    YOUR_HOME: APP_PATH + "/quote/yourHome/{0}",
    YOUR_LICENSE: APP_PATH + "/quote/yourLicense/{0}",
    DRIVING_HISTORY: APP_PATH + "/quote/drivingHistory/{0}",
    INCIDENTS: APP_PATH + "/quote/incidents/{0}",
    CURRENT_INSURANCE: APP_PATH + "/quote/currentInsurance",
    INSURANCE_HISTORY: APP_PATH + "/quote/insuranceHistory",
    NEW_POLICY: APP_PATH + "/quote/yourNewPolicy",
    CONTACT_INFO: APP_PATH + "/quote/contactInfo",
    COVERAGES: APP_PATH + "/quote/coverages",
    RESULT: APP_PATH + "/quote/result",
    CHECKOUT: APP_PATH + "/quote/checkout",
    AGENCIES: APP_PATH + "/quote/agencies",
    FQ_CARS: APP_PATH + "/full-quote/car/{0}",
    FQ_DRIVERS: APP_PATH + "/full-quote/driver/{0}",
    FQ_POLICY_DETAILS: APP_PATH + "/full-quote/policyDetails",
    FQ_FINALIZE: APP_PATH + "/full-quote/finalize",
    FQ_PAYMENT: APP_PATH + "/full-quote/payment",
    FQ_ADDITIONAL_DRIVERS: APP_PATH + "/full-quote/add-drivers",
    FQ_VIOLATIONS: APP_PATH + "/full-quote/violations/{0}",
    FQ_FINISH: APP_PATH + "/full-quote/finish",
    FQ_DOCUMENTS: APP_PATH + "/full-quote/documents",
    FQ_GOODTOGO: APP_PATH + "/full-quote/goodtogo",
    FQ_ESIGNATURE: APP_PATH + "/full-quote/esignature/{0}",
    RTR_CHECKOUT: APP_PATH + "/rtr/checkout/{0}",
    AGENT_LANDING_QUOTE: APP_PATH + "/quote/landing/{0}"
}

export const QUOTE_STEPS = {
    START: "START",
    CHANGE_ZIP: "CHANGE_ZIP",
    VEHICLE_YMM: "VEHICLE_YMM",
    VEHICLE_DETAILS: "VEHICLE_DETAILS",
    HOW_YOU_DRIVE: "HOW_YOU_DRIVE",
    ABOUT_YOU: "ABOUT_YOU",
    EDUCATION_EMPLOYMENT: "EDUCATION_EMPLOYMENT",
    YOUR_HOME: "YOUR_HOME",
    YOUR_LICENSE: "YOUR_LICENSE",
    DRIVING_HISTORY: "DRIVING_HISTORY",
    CURRENT_INSURANCE: "CURRENT_INSURANCE",
    INSURANCE_HISTORY: "INSURANCE_HISTORY",
    NEW_POLICY: "NEW_POLICY",
    CONTACT_INFO: "CONTACT_INFO",
    COVERAGES: "COVERAGES",
    RTR_COVERAGES: "RTR_COVERAGES",
    SUB_COVERAGES: "SUB_COVERAGES"
}

export const FULL_QUOTE_STEPS = {
    CARS: "CARS",
    DRIVERS: "DRIVERS",
    ADDITIONAL_DRIVERS: "ADDITIONAL_DRIVERS",
    POLICY_DETAILS: "POLICY_DETAILS",
    FINALIZE: "FINALIZE",
    PAYMENT: "PAYMENT",
    FINISH: "FINISH"
}

export const ACTIONS = {
    QUOTE_STARTED: "QUOTE_STARTED",
    CHANGE_ZIP: "CHANGE_ZIP",
    QUOTE_STEP_PASSED: "QUOTE_STEP_PASSED",
    QUOTE_STEP_CHANGED: "QUOTE_STEP_CHANGED",
    QUOTE_CREATED: "QUOTE_CREATED",
    UPDATE_VEHICLES: "API.UPDATE_VEHICLES",
    UPDATE_VEHICLE: "UPDATE_VEHICLE",
    UPDATE_DRIVER: "UPDATE_DRIVER",
    UPDATE_INSURANCE: "UPDATE_INSURANCE",
    UPDATE_CONTACT_INFO: "UPDATE_CONTACT_INFO",
    SELECT_COVERAGE_CONFIG: "SELECT_COVERAGE_CONFIG",
    LOAD_QUOTE: "LOAD_QUOTE",
    FILL_EXTERNAL_QUOTE: "FILL_EXTERNAL_QUOTE",
    FILL_RTR_QUOTE: "FILL_RTR_QUOTE",
    PAYMENT_CHOICE_SELECTED: "PAYMENT_CHOICE_SELECTED",
    RTR_PAYMENT_CHOICE_SELECTED: "RTR_PAYMENT_CHOICE_SELECTED",
    LOAD_CONTACT_INFO: "LOAD_CONTACT_INFO",
    SET_CARRIER_CUSTOMIZATION: "SET_CARRIER_CUSTOMIZATION",
    RESET_APP_STATE: "RESET_APP_STATE",
    UPDATE_VIOLATION_LIST: "UPDATE_VIOLATION_LIST",
    SET_POST_QUOTE_STATE: "SET_POST_QUOTE_STATE",
    SET_MAP_QUOTE_STATE: "SET_MAP_QUOTE_STATE"
}

export const EXT_QUOTE_ACTIONS = {
    UPDATE_VEHICLE: "EXT_QUOTE_UPDATE_VEHICLE",
    UPDATE_DRIVER: "EXT_QUOTE_UPDATE_DRIVER",
    UPDATE_AGREEMENT: "EXT_QUOTE_UPDATE_AGREEMENT",
    RESET_AGREEMENT: "EXT_QUOTE_RESET_AGREEMENT",
    UPDATE_VIOLATIONS: "EXT_QUOTE_UPDATE_VIOLATIONS",
    UPDATE_DOCUMENTS: "EXT_QUOTE_UPDATE_DOCUMENTS",
    UPDATE_PAYMENT_PLAN: "EXT_UPDATE_PAYMENT_PLAN",
    RERATE_QUOTE: "EXT_QUOTE_RERATE_QUOTE",
    RESET_QUOTE_EFF_DATE: "EXT_QUOTE_RESET_QUOTE_EFF_DATE",
    RESET_QUOTE_TIME_STAMP_EFF_DATE: "RESET_QUOTE_TIME_STAMP_EFF_DATE",
    RELOAD_QUOTE_PMT_INFO: "RELOAD_QUOTE_PMT_INFO",
    BIND_QUOTE: "EXT_QUOTE_BIND_QUOTE",
    FILL_E_SIGNATURES: "FILL_E_SIGNATURES",
    UPDATE_ADDITIONAL_DRIVERS: "UPDATE_ADDITIONAL_DRIVERS"
}

export const YES_NO = {
    YES: "Yes",
    NO: "No"
}

export const VALIDATION = {
    REQUIRED: "Required",
    INVALID_EMAIL: "Invalid email format",
    DATE_FORMAT: "Please specify date in mm/dd/yyyy format",
    INVALID_DATE: "Invalid date",
    INVALID_PHONE: "Invalid phone",
    INVALID_INSURED: "Invalid insured name",
    INVALID_INSURED_AGE: "The named insured must be 18 years of age or older to purchase an auto insurance policy",
    INVALID_DRIVER_AGE: "Driver must be 16 years of age or older",
    INVALID_GETHERRY_EMAIL: "Please enter an email address other than @getjerry.com"
}

export const QUOTE = {
    MIN_INSURED_DRIVER_AGE: 18,
    MIN_DRIVER_AGE: 16
}

export const QUOTE_QUESTIONS = {
    YES_NO: {
        YES: "Yes",
        NO: "No"
    },

    VEHICLE_DETAILS: {
        OWNERSHIP: {
            OWN: "Own",
            LEASE: "Lease"
        },
    },

    VEHICLE_USE: {
        COMMUTING: "Commute",
        PERSONAL: "Personal",
        BUISNESS: "Business",
        FARMING: "Farming",
        OTHER: "Other"
    },

    ABOUT_YOU: {
        GENDER: {
            MALE: "Male",
            FEMALE: "Female"
        },

        MARITAL_STATUS: {
            SINGLE: "Single",
            MARRIED: "Married",
            DIVORCED: "Divorced",
            WIDOWED: "Widowed",
            CIVIL_UNION: "Civil Union",
            SEPARATED: "Separated",
            DOMESTIC_PARTNER: "Domestic Partner",
            REGISTERED_DOMESTIC_PARTNER: "Registered Domestic Partner"
        },
    },

    INCIDENTS: {
        TYPES: {
            ACCIDENT: "Accident",
            TICKET: "Ticket",
            CLAIM: "Claim"
        },

        DESCRIPTION: {
            ACCIDENT: {
                AT_FAULT_PD_LESS_1000: "At fault (property damage < $1,000)",
                AT_FAULT_PD_GREATER_1000: "At fault (property damage > $1,000)",
                AT_FAULT_INJURY: "At fault (injury)",
            },

            TICKET: {
                SPEEDING_1_15_OVER_LIMIT: "Speeding: 1 - 15 mph over the limit",
                SPEEDING_16_34_OVER_LIMIT: "Speeding: 16 - 34 mph over the limit",
                SPEEDING_35_OVER_LIMIT: "Speeding: 35 mph or more over the limit",
            },

            CLAIM: {
                THEFT_VANDALISM: "Theft or vandalism",
                LARGE_COMP_CLAIM: "Large comprehensive claim (over $1,000)",
                SMALL_COMP_CLAIM: "Small comprehensive claim",
                UM_UIM_CLAIM: "Uninsured / Underinsured motorist claim",
                OTHER: "All other non-accident (weather related loss - hail, flood, etc.)"
            }
        },
    },

    EDUCATION_EMPLOYMENT: {
        EDUCATION: {
            HIGH_SCHOOL: "High school",
            ASSOCIATE: "Associate",
            BACHELORS: "Bachelors",
            LESS_HIGH_SCHOOL: "Less than high school",
            VOCATIONAL: "Vocational",
            MASTERS: "Masters",
            MEDICAL_SCHOOL: "Medical school",
            LAW_SCHOOL: "Law school",
            DOCTORATE: "Doctorate"
        },

        EMPLOYMENT: {
            EMPLOYED: "Employed",
            SELF_EMPLOYED: "Self-Employed",
            RETIRED: "Retired",
            STUDENT_HIGH_SCHOOL: "Full Time Student - High School",
            STUDENT_TRADE_SCHOOL: "Full Time Student - Trade School",
            STUDENT_UNDERGRADUATE: "Full Time Student - Undergraduate",
            STUDENT_GRADUATE: "Full Time Student - Graduate",
            UNEMPLOYED: "Unemployed",
            OTHER: "Other",
            MILITARY: "Military",
            RETIRED_MILITARY: "Retired Military",
            HOMEMAKER: "Homemaker"
        },

        MILITARY_BRANCH: {
            ARMY: "Army",
            NAVY: "Navy",
            AIR_FORCE: "Air Force",
            MARINES: "Marines",
            COAST_GUARD: "Coast Guard",
        }
    },

    YOUR_HOME: {
        RESIDENCE_YEARS: {
            LESS_SIX_MONTH: "Less than 6 months",
            ONE_YEAR: "1 year",
            TWO_YEAR: "2 years",
            THREE_YEAR: "3 years",
            FOUR_YEAR: "4 years",
            FIVE_YEAR: "5 years",
            SIX_YEARS: "6+ years",
        },

        HOME_OWNERSHIP: {
            OWN: "Own",
            RENT: "Rent",
            OTHER: "Other"
        },

        HOME_TYPE: {
            SINGLE_FAMILY: "Single family",
            CONDO: "Condo",
            MOBILE_HOME: "Mobile home"
        },
    },

    YOUR_LICENSE: {
        CURRENT_LICENSE_STATUS: {
            SUSPENDED: "Suspended",
            NON_LICENSED: "Non-licensed",
            PERMIT: "Permit",
            VALID_COMMERCIAL_LICENSE: "Valid commercial license",
            VALID_CANADIAN_LICENSE: "Valid Canadian License",
            OTHER_VALID_FOREIGN_LICENSE: "Other valid foreign license",
            EXPIRED: "Expired",
            RESTRICTED: "Restricted",
            SURRENDERED: "Surrendered",
            PERMANENTLY_REVOKED: "Permanently revoked",
            MATRICULA_INTERNATIONAL_LICENSE: "Matricula/International License",
            REVOKED_SUSPENDED: "Revoked/Suspended",
        },
        CURRENT_LICENSE_STATE: {
            CALIFORNIA: "California",
            TEXAS: "Texas",
            OTHER_US_STATE: "Other US State",
            MEXICO: "Mexico",
            OTHER: "Other"
        }
    },

    CURRENT_INSURANCE: {
        CURRENT_INSURANCE_DETAILS: {
            OWN_POLICY: "I have my own policy",
            ANOTHER_POLICY_PROOF_OF_INSURANCE: "On another's policy with proof of insurance",
            ANOTHER_POLICY_WITHOUT_PROOF_OF_INSURANCE: "On another's policy without proof of insurance",
            OVERSEAS: "I've been deployed overseas",
            JUST_ACQUIRED_CAR: "I just acquired a car",
            POLICY_EXPIRED_MORE_30_DAYS: "My policy expired more than 30 days ago",
            POLICY_EXPIRED_LESS_30_DAYS: "My policy expired less than 30 days ago",
        },

        WAS_UNINSURED: {
            NO: "No, I was continuously insured",
            WITHIN_SIX_MONTHS: "Yes, within the last 6 months",
            WITHIN_THREE_YEARS: "Yes, within the last 3 years"
        },

        UNINSURED_PERIOD: {
            WEEK: "1-7 days",
            MONTH: "8-30 days",
            TWO_MONTHS: "31-60 days",
            THREE_MONTHS: "61-90 days",
            MORE_THEN_THREE_MONTHS: "90+ days"
        },

        INSURED_PERIOD: {
            SIX_MONTHS: "6 – 12 Months",
            TWELVE_MONTHS: "12 Months +"
        }
    },

    INSURANCE_HISTORY: {
        CURRENT_INSURANCE_COMPANY_PERIOD: {
            LESS_ONE_YEAR: "Less than 1 year",
            ONE_YEAR: "1 year",
            TWO_YEARS: "2 years",
            THREE_YEARS: "3 years",
            FOUR_YEARS: "4 years",
            FIVE_YEARS: "5 years",
            SIX_TEN_YEARS: "6-10 years",
            ELEVEN_FIFTEEN_YEARS: "11-15 years",
            SIXTEEN_TWENTY_YEARS: "16-20 years",
            MORE_TWENTY_YEARS: "21 years"
        },

        BI_LIMITS: {
            MINIMUM: "Minimum Limit",
            LESS_THAN_50_100: "Greater than minimum but less than 50/100",
            LESS_THAN_100_300: "50/100 or greater but less than 100/300",
            GREATER_THAN_100_300: "100/300 or greater"
        }
    },

    NEW_POLICY: {
        EFF_DATE_OPTIONS: {
            TODAY: "Today",
            TOMORROW: "Tomorrow",
            WHEN_POLICY_EXPIRES: "When my policy expires",
            OTHER: "Other"
        }
    }
}

export const EVENTS = {
    VALIDATION_FAILURE: "VALIDATION_FAILURE",
    API_CALL_FAILURE_BAD_REQUEST: "API_CALL_FAILURE_BAD_REQUEST",
    API_CALL_FAILURE_COMMON: "API_CALL_FAILURE_COMMON",
    QUOTE_STEP_CHANGED: "QUOTE_STEP_CHANGED",
    UNAUTHORIZED: "UNAUTHORIZED"
}

export const MILEAGE_QUESTIONS = {
    MILEAGE: {
        LESS_THAN_THREE: "<=3",
        //LESS_THAN_FIVE: "< 5",
        FIVE: "5",
        TEN: "10",
        //FIFTEEN: "15+",
        TWENTY: "20+"
        //TWENTY_FIVE: "25",
        //THIRTY: "30+",
    }
};

export const MARIED_TYPES = [
    QUOTE_QUESTIONS.ABOUT_YOU.MARITAL_STATUS.MARRIED,
    QUOTE_QUESTIONS.ABOUT_YOU.MARITAL_STATUS.REGISTERED_DOMESTIC_PARTNER
];


export const ADDITIONAL_DRIVER_REASONS = {
    EXCLUDE_REASONS: {
        NOT_LICENSED: "Not Licensed & Doesn’t Drive",
        HAS_OWN_INSURANCE: "Has Own Insurance"
    },

    DISREGARD_REASONS: {
        NOT_IN_HOUSEHOLD: "Not In Household",
        I_DONT_KNOW_THIS_PERSON: "I Don't Know This Person"
    }
}